import React from 'react';

// Pesticide Usage Report + Tracker.
// This is the self-contained bilingual (EN/ES) tool from XpertPests, served from
// /public/pesticide-report.html and embedded here so it slots into the dashboard shell.
export default function PesticideReports() {
  return (
    <div className="w-full" style={{ height: 'calc(100vh - 64px)' }}>
      <iframe
        title="Pesticide Usage Report"
        // ?v bust: forces a fresh fetch past any copy a browser cached with the
        // old X-Frame-Options: DENY header (which blocked this same-origin iframe).
        src="/pesticide-report.html?v=2"
        className="w-full h-full"
        style={{ border: 0 }}
      />
    </div>
  );
}
